import {useHttp} from "../../../services/HttpService";
import {getEntlastungssystemEndpoint, getEntlastungstypEndpoint} from "../../../services/WertelistenService";
import React, {useState} from "react";

export default function EntlastungstypSelector(props) {
    const [entlastungstypOptionen] = useHttp(getEntlastungstypEndpoint);
    const [entlastungssystemOptionen] = useHttp(getEntlastungssystemEndpoint);
    const [selectableEntlastungssysteme, setSelectableEntlastungssysteme] = useState([]);

    const calcSelectableEntlastungssysteme = (newVal) => {
        if (newVal && newVal.entlastungssysteme) {
            const filteredItems = filterAllowedValues(newVal.entlastungssysteme, entlastungssystemOptionen.data);
            setSelectableEntlastungssysteme(filteredItems);
        } else {
            setSelectableEntlastungssysteme([]);
        }
    };

    const filterAllowedValues = (allowedValues, completeData) => {
        const allowedIds = allowedValues.map(item => item.id);
        return completeData.filter(item => allowedIds.includes(item.id));
    }

    return (
        <div className="gridl" style={{gridTemplateColumns: "1fr 1fr"}}>
            {props.formFactory.renderAutocomplete(
                "entlastungstyp",
                "entlastungstyp",
                "Anlagensystem",
                entlastungstypOptionen.data,
                "value",
                "id",
                entlastungstypOptionen.loading,
                false,
                props.disabled,
                null,
                [
                    {id: "entlastungssystem", calcDependentVal: calcSelectableEntlastungssysteme}
                ]
            )}
            {props.formFactory.renderAutocomplete(
                "entlastungssystem",
                "entlastungssystem",
                "Verfahren",
                selectableEntlastungssysteme,
                "value",
                "id",
                entlastungssystemOptionen.loading,
                false,
                props.disabled,
            )}
        </div>
    );
}
